import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'



const TecIndexMain = () => {

  useEffect(()=>{

    document.getElementById('tec-sectionMain').style.display = "none";
   
  setTimeout(()=>{
    document.getElementById('tec-lableMainA').style.position="static"  
    document.getElementById('tec-lableMainB').style.position="static"
    document.getElementById('tec-lableMainC').style.position="static"  
    // document.getElementById('tec-lableMainD').style.position="static" 
   
 
    document.getElementById('tec-sectionMain').style.display = "block";
    



  },1000)
},[])

  return (
    <div className='tec-addmain'>
      
      
   
         <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">INDEX</span></span>
 <div className='tec-addmain-back'>
<Link to="/Tecsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
</div>
 </p> 

 {/* <hr></hr> */}
 </div>
    </div>    


    <ul id="tecLableSection">
  <li className="tecdot tecdottyIndex1"id="tec-lableMainA"></li>
  <li className="tecdot tecdottyIndex2" id="tec-lableMainB"></li>
  <li className="tecdot tecdottyIndex3" id="tec-lableMainC"></li>
  {/* <li className="tecdot tecdottyIndex4" id="tec-lableMainD"></li> */}
  
  </ul>
  <ul id='tec-sectionMain'>

<li className='tectitle1 tectitle-animate' id="tec-touchMainA"><Link to="/TecFirst">Heading</Link></li>
<li className='tectitle2 tectitle-animate'  id="tec-touchMainB"><Link to="/TecExpertise"> Expertise</Link></li>
<li className='tectitle3 tectitle-animate'  id="tec-touchMainC"><Link to="/TecLeaders"> Leaders</Link></li>

{/* <li className='tectitle4 tectitle-animate'  id="tec-touchMainD"><Link to="/TecProduct">Our Products</Link></li> */}



 </ul>
   
     <div>
    
  
        </div>
  


        </div>
  )
}

export default TecIndexMain
